module.exports = "<div class=\"progress\">\n  <p>PROGRESS</p>\n  <span></span>\n</div>\n";